import { useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  getPackagePeriods,
  getPackages,
  getPromotionPeriods,
  mapPurchasePackage,
} from '../PackagesSection.helpers';
import type { PackagesListResponse, PackagesListVariables } from '../api';
import { GET_PACKAGES_LIST } from '../api';
import { useCurrentUser } from '@/features/Profile/core/hooks/useCurrentUser';

const DEFAULT_PACKAGE_PERIOD = 30;

export function usePackagesList() {
  const [requestedPeriod, setRequestedPeriod] = useState(
    DEFAULT_PACKAGE_PERIOD
  );
  const { shop, loading: isUserLoading } = useCurrentUser();
  const segment = shop?.segment ?? undefined;
  const isBrowser = typeof window !== 'undefined';
  const { data, loading: isPackagesLoading } = useQuery<
    PackagesListResponse,
    PackagesListVariables
  >(GET_PACKAGES_LIST, {
    variables: segment ? { segment: segment.toUpperCase() } : undefined,
    skip: !isBrowser || !segment,
    fetchPolicy: 'cache-and-network',
  });
  const packageOffers = getPackages(data);
  const periods = getPackagePeriods(packageOffers);
  const promotionPeriods = getPromotionPeriods(packageOffers);
  const selectedPeriod = periods.includes(requestedPeriod)
    ? requestedPeriod
    : periods[periods.length - 1];

  return {
    loading: isUserLoading || isPackagesLoading,
    packageOffers,
    packages:
      selectedPeriod === undefined
        ? []
        : packageOffers.map(item => mapPurchasePackage(item, selectedPeriod)),
    periods,
    promotionPeriods,
    selectedPeriod,
    selectPeriod: setRequestedPeriod,
  };
}
